module.exports = "/assets/45651613c8dcd973096cf7365475b09c.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/B6.png
// module id = 2348
// module chunks = 0